import { HostBinding, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MetaService } from '@ngx-meta/core';

import { CarregarCarrosselDOM } from 'app/shared/carrossel/carrossel.dom';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { NoticiasService } from '../shared/noticias.service';

import { PesquisarNoticiaPayload } from 'models/noticia';

const rexStyle = /<style .*>(.|\n)*?<\/style>/gm;

@Component({
  selector: 'app-noticias-detalhe',
  templateUrl: './noticias-detalhe.component.html',
  styleUrls: ['./noticias-detalhe.component.scss'],
  animations: [routerTransition],
})
export class NoticiasDetalheComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  noticia;
  relacionadas = [];
  loading = true;
  loadingRelacionadas = false;
  noticiaURL = '';

  constructor(
    private service: NoticiasService,
    private route: ActivatedRoute,
    private readonly meta: MetaService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.loading = true;
      this.carregarNoticia(params['slug']);
    });

    this.noticiaURL = window.location.href;
  }

  carregarNoticia(slug) {
    this.service.query({ slug })
      .then((resp: PesquisarNoticiaPayload) => {
        if (resp.data.length) {
          this.noticia = resp.data[0];
          this.loading = false;

          // setting meta tags
          this.meta.setTitle(this.noticia.title.rendered);
          this.meta.setTag('og:description', this.noticia.excerpt.rendered);
          this.meta.setTag('og:image', this.noticia.featuredMedia.thumbnail.source_url);

          if (rexStyle.test(this.noticia.content.rendered)) {
            this.noticia.content.rendered = this.noticia.content.rendered.replace(rexStyle, '');
          }

          if (this.noticia.tags.length) {
            const tags = this.noticia.tags[0].id;
            this.carregarNoticiasRelacionadas(tags);
          }

          setTimeout(() => {
            CarregarCarrosselDOM('#wp-container');
          }, 100);
        }
      });
  }

  carregarNoticiasRelacionadas(tags) {
    this.loadingRelacionadas = true;
    return this.service.query({ per_page: 3, tags })
      .then((resp: PesquisarNoticiaPayload) => {
        if (resp.data.length) {
          this.relacionadas = resp.data;
          this.loadingRelacionadas = false;
        }
      });
  }
}
